/*
 * O interruptor de situação: ligado é ativo.
 *
 * `<button role="switch">`, e não `@radix-ui/react-switch`: o botão nativo já resolve
 * foco, Espaço, Enter e o estado para leitor de tela (design D17). O estado se lê pela
 * POSIÇÃO do botão, além da cor, para sobreviver a daltonismo.
 *
 * O interruptor só pede. Quem decide é `useAlternarSituacao`, que abre a confirmação
 * com motivo: o estado na tela só muda quando a API confirmar, e por isso `ligado`
 * vem sempre de fora.
 *
 * `apagado` é o ligado que não vale agora, porque quem está acima dele está desligado: o
 * convênio de uma conta inativa. A POSIÇÃO continua dizendo o que está gravado, e o verde
 * sai, porque verde aqui se lê como "emite".
 */
export function TrilhoDoInterruptor({
  ligado,
  apagado = false,
}: {
  ligado: boolean;
  apagado?: boolean;
}) {
  const aceso = ligado && !apagado;

  return (
    <span
      aria-hidden="true"
      className={[
        "inline-flex h-[18px] w-8 shrink-0 items-center rounded-full border p-[2px]",
        "transition-colors motion-reduce:transition-none",
        aceso ? "border-pago/40 bg-pago/15" : "border-fio-forte bg-superficie-2",
      ].join(" ")}
    >
      <span
        className={[
          "size-3 rounded-full transition-transform motion-reduce:transition-none",
          ligado ? "translate-x-[14px]" : "",
          aceso ? "bg-pago" : "bg-texto-3",
        ].join(" ")}
      />
    </span>
  );
}

export function Interruptor({
  ligado,
  rotulo,
  aoAlternar,
  desabilitado = false,
  apagado = false,
}: {
  ligado: boolean;
  /** Nome acessível, e diz o que `ligado` significa: "Convênio ativo". */
  rotulo: string;
  aoAlternar: () => void;
  desabilitado?: boolean;
  apagado?: boolean;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={ligado}
      aria-label={rotulo}
      disabled={desabilitado}
      onClick={aoAlternar}
      className="inline-flex rounded-full disabled:cursor-not-allowed disabled:opacity-50"
    >
      <TrilhoDoInterruptor ligado={ligado} apagado={apagado} />
    </button>
  );
}
